import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapAceEditor = React.lazy(function () {
    return import('../../bootstrap-components/components/BTAceEditor');
});
var bootStrapAceEditor = function (props) {
    return (React.createElement(BootStrapAceEditor, { mode: props.mode, collapseEnable: props.collapseEnable, styleName: props.styleName, label: props.label, ioTheme: props.ioTheme, ioMode: props.ioMode, displayType: props.displayType, mandatory: props.mandatory, placeholder: props.editorMode, editorMode: props.editorMode, editorTheme: props.editorTheme, handleChange: props.handleChange, value: props.value, fontSize: props.fontSize, showGutter: props.showGutter, enableBasicAutocompletion: props.enableBasicAutocompletion, enableLiveAutocompletion: props.enableLiveAutocompletion, showLineNumbers: props.showLineNumbers, hasError: props.hasError, errorMessage: props.errorMessage, configId: props.configId }));
};
export var AceEditor = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapAceEditor(props);
            break;
        default:
            componentToDisplay = bootStrapAceEditor(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
AceEditor.defaultProps = {
    styleName: 'primary',
    label: 'CodeEditor',
    ioTheme: themes[0],
    ioMode: 'light',
    fontSize: 14,
};
export default AceEditor;
//# sourceMappingURL=AceEditor.js.map